import { render, staticRenderFns } from "./pie-echarts.vue?vue&type=template&id=5b7785f4"
import script from "./pie-echarts.vue?vue&type=script&lang=ts"
export * from "./pie-echarts.vue?vue&type=script&lang=ts"
import style0 from "./pie-echarts.vue?vue&type=style&index=0&id=5b7785f4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports